/**
 * author: Ananthapadmanabhan V K
 */
import Multiselect from 'multiselect-react-dropdown';
import React, { Fragment, useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { withTranslation } from 'react-i18next';
import { toast } from "react-toastify";
import { LS_AUTHORITY_KEY, USER_ROLE } from '../../../core/constants/common';
import AssignSubscriptionService from '../../../core/service/AssignSubscriptionService';
import GeneralDisclosureService from '../../../core/service/GeneralDisclosureService';
import SadminSubscriptionService from '../../../core/service/SadminSubscriptionService';
import './AssignSubscription.scss';

const AssignSubscription = ({ t }) => {
  const authority = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const filterBy = () => true;
  const [companyid, setCompanyId] = useState("");
  const [regulations, setRegulations] = useState([]);
  const [plans, setPlans] = useState([]);
  const [planId, setPlanId] = useState("");
  const [regulationsubmitarray, setRegulationSubmitArray] = useState([]);
  const [disclosures, setDisclosures] = useState([]);
  const [disclosureIds, setDisclosureIds] = useState([]);

  useEffect(() => {
    getRegulations();
    getPlans();
    getDisclosures();
  }, []);

  const getRegulations = async (e) => {
    SadminSubscriptionService.getRegulations(true)
      .then((response) => {
        var resRegulations = response.data;
        setRegulations([...resRegulations]);
      })
      .catch((error) => {
      });
  };

  const getPlans = async (e) => {
    AssignSubscriptionService.getPlans()
      .then((response) => {
        setPlans([...response.data]);
        if (response.data[0]) {
          setPlanId(response.data[0].id)
        }
      })
      .catch((error) => {
      });
  };

  const handleSearch = (query) => {
    setIsLoading(true);
    AssignSubscriptionService.getCompanyList(query)
      .then((response) => {
        const options = response.data?.map((i) => ({
          id: i.companyId,
          legalName: i.legalName,
        }));
        setOptions(options);
        setIsLoading(false);
      })
      .catch((error) => {
      });
  };

  const onSelectRegulation = (selectedList, selectedItem) => {
    const array = arrayFormatter(selectedList);
    setRegulationSubmitArray([...array]);
  }
  const onRemoveRegulation = (selectedList, removedItem) => {
    const array = arrayFormatter(selectedList);
    setRegulationSubmitArray([...array]);
  }

  const arrayFormatter = (selectedList) => {
    const array = [];
    for (let i = 0; i < selectedList.length; i++) {
      array.push(selectedList[i].id)
    }
    return array;
  }

  const handleSubmit = async (e) => {
    const body = {
      companyId: companyid,
      regulationIds: regulationsubmitarray,
      disclosureIds: disclosureIds
    };
    AssignSubscriptionService.onSubmit(planId, body)
      .then((response) => {
        if (response.status === 200 || response.status === 201 || response.status === 204) {
          toast.success('Success', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch((error) => {
        toast.error(error.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });

  }

  const getDisclosures = () => {
    GeneralDisclosureService.getDisclosures(authority.roles.includes(USER_ROLE.SUPER_ADMIN))
			.then((response) => {
				if (response.status !== 200) return;

				setDisclosures(response.data);
			})
			.catch((error) => {
			});
  };

  const onSelectGD = (selectedList, selectedItem) => {
    setDisclosureIds(arrayFormatter(selectedList));
  }
  const onRemoveGD = (selectedList, removedItem) => {
    setDisclosureIds(arrayFormatter(selectedList));
  }

  return (
    <div className="AssignSubscription">
      <div className="List_header">
        <h5 className="MH">{t("AssignSubscription.label")}</h5>
      </div>
      <div>
        <Form>
          <div className="row m-0">
            <div className="col-lg-4 p-0">
              <div className="p-2">
                <label className="mb-1">{t("company.label")} <span className='text-red'>*</span></label>
                <AsyncTypeahead
                  filterBy={filterBy}
                  id="company"
                  isLoading={isLoading}
                  labelKey="legalName"
                  minLength={2}
                  onSearch={handleSearch}
                  onChange={(selected) => {
                    if (selected[0]) {
                      setCompanyId(selected[0].id)
                    }
                  }}
                  options={options}
                  placeholder={t("Search.label")}
                  renderMenuItemChildren={(option, props) => (
                    <Fragment>
                      <span>{option.legalName}</span>
                    </Fragment>
                  )}
                />
              </div>
              <div className="p-2">
                <label className="mb-1">{t("SubscriptionPlan.label")} <span className='text-red'>*</span></label>
                <select
                  className="form-select"
                  onChange={(e) => {
                    setPlanId(e.target.value)
                  }}
                >
                  <option value="" disabled hidden>
                    {t("Select.label")}
                  </option>
                  {plans.map((items) => (
                    <option value={items.id} key={items.id}>
                      {items.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="p-2">
                <label className="mb-1">{t("Regulation.label")}</label>
                <Multiselect
                  options={regulations}
                  onSelect={onSelectRegulation}
                  onRemove={onRemoveRegulation}
                  displayValue="name"
                />
              </div>
              <div className="p-2">
                <label className="mb-1">{t("GeneralDisclosures.label")} <span className='text-red'>*</span></label>
                <Multiselect
                  id="gdMultiSelect"
                  key="gdMultiSelect"
                  options={disclosures}
                  onSelect={onSelectGD}
                  onRemove={onRemoveGD}
                  displayValue="name"/>
              </div>
              <div className="text-center">
                <Button variant="primary" onClick={handleSubmit} className="sbmBtn">
                  {t("Assign.label")}
                </Button>
              </div>
            </div>

          </div>
        </Form>
      </div>
    </div>
  )
};

export default withTranslation()(AssignSubscription);
